import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, EMPTY, from, of } from 'rxjs';
import axios from 'axios-observable';
import { UserModel } from '@/models';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { FetchAllUsersPayload } from '@/store/slices/staff/users.slice';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';

export const fetchAllUsersEpic: PayloadEpic<FetchAllUsersPayload, UserModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.users.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.users.setIsLoading(true)),
            fetchUsersRequest(payload).pipe(
                switchMap(({ data }) => from([
                    actions.users.setAll(data.results),
                    actions.users.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchAllUsersEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.users.setIsLoading(false)),
        )),
    );
};

const fetchUsersRequest = (payload: FetchAllUsersPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<UserModel>>(`${apiEndpoints.users()}?${searchParams}`);
};
